import { For } from '@chakra-ui/react';
import Popup from '@components/map/popup/Popup';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectPopupsByMapId } from '@redux/maps/maps.selectors';
import { getPopupDataType } from '@utils/popup.utils';

export function Popups() {
  const popups = useSelectorWithMapId(selectPopupsByMapId);

  return (
    <For each={popups}>
      {(popup) => {
        const dataType = getPopupDataType(popup);
        const dataTypeKeyPart = dataType ? `-${dataType}` : '';
        return <Popup key={`popup-${popup.type}${dataTypeKeyPart}`} popup={popup} />;
      }}
    </For>
  );
}
